import { useId } from 'react'

/**
 * Returns a stable, deterministic choice from an array of options.
 *
 * Uses React's useId to pick the same option consistently across renders
 * and server/client hydration. Useful for skeleton loaders and other UI
 * that needs varied but stable values.
 *
 * @example
 * const width = useStableChoice(['60%', '75%', '50%', '85%'])
 * const color = useStableChoice(['blue', 'green', 'purple'])
 */
export function useStableChoice<T>(options: readonly T[]): T {
    if (options.length === 0) {
        throw new Error('useStableChoice requires a non-empty array')
    }
    const id = useId()
    return options[id.charCodeAt(2) % options.length]
}
